import { ForwardDealDocuments } from '@/components/transactions-page/forwardDealDocuments-page';
import useRefresh from '@/hooks/use-refresh';
import { Helmet as Head } from 'react-helmet';

const ForwardDealDocumentsPage = () => {
  useRefresh();
  return (
    <>
      <Head>
        <title>Forward Deal Documents</title>
      </Head>
      <ForwardDealDocuments />
    </>
  );
};

export default ForwardDealDocumentsPage;
